export enum enumVerandaModelType {
    Cube = 1,
    Deluxe = 2,
    Classic = 3
}